module.exports = __webpack_public_path__ + "img/Instagram.79a4d7f8.svg";